// src/pages/Clients/components/ClientUsersTab.jsx
import React, { useEffect, useMemo, useState } from "react";
import { Table, Popconfirm, App } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { fetchClientUsers, removeClientUser } from "../clientsSlice";
import { getAccessType } from "../../../lib/functions";
import { useIsAdminUser } from "../../../lib/accessList";

const ClientUsersTab = ({ onCreate, onEdit }) => {
  const dispatch = useDispatch();
  const { message } = App.useApp();
  const { clientUsers, loading } = useSelector((s) => s.clientsSuite);
  let [access_type, access_type_set] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const authInfo = useSelector((state) => state.auth?.auth_info);
  const isAdminUser = useIsAdminUser();

  const canEdit = authInfo?.can_edit === 1;
  const canDelete = authInfo?.can_delete === 1;


  useEffect(() => {
    const access = getAccessType("clients_entry");
    access_type_set(access);
  }, []);

  const columns = useMemo(() => [
    { title: "User Name", dataIndex: "name", key: "name" },
    { title: "Client Name", dataIndex: "client_name", key: "client_name" },
    { title: "Email", dataIndex: "email", key: "email" },
    { title: "Designation", dataIndex: "designation_name", key: "designation_name" },
    { title: "Phone No", key: "phone", render: (_, row) => (row.country_code && row.contact_no) ? `+${row.country_code} ${row.contact_no}` : "" },
    ...(access_type === "WRITE"
      ? [
        {
          title: "",
          key: "actions",
          align: "right",
          render: (_, row) => (
            <>
              <EditOutlined
                style={{
                  marginRight: 16, cursor: (isAdminUser || canEdit) ? "pointer" : "not-allowed",
                  color: (isAdminUser || canEdit) ? "#1677ff" : "#ccc",
                }}
                onClick={() => {
                  if (!(isAdminUser || canEdit)) return;
                  onEdit(row);
                }}
              />
              <Popconfirm
                title="Delete client user?"
                okText="Delete"
                onConfirm={async () => {
                  if (!(isAdminUser || canDelete)) return;
                  await dispatch(removeClientUser(row.id));
                  message.success("Client user deleted");
                  dispatch(fetchClientUsers());
                }}
                disabled={!(isAdminUser || canDelete)}
              >
                <DeleteOutlined style={{
                  cursor: (isAdminUser || canDelete) ? "pointer" : "not-allowed",
                  color: (isAdminUser || canDelete) ? "#ff4d4f" : "#ccc",
                }} />
              </Popconfirm>
            </>
          ),
        }] : [])
  ], [dispatch, onEdit, access_type]);

  return (
    <Table
      rowKey="id"
      dataSource={clientUsers}
      columns={columns}
      loading={loading.users}
      scroll={{ x: "max-content" }}
      pagination={{
        current: currentPage,
        pageSize: pageSize,
        total: clientUsers.length,
        showQuickJumper: true,
        showSizeChanger: true,
        pageSizeOptions: [10, 20, 50, 100],
        onChange: (page) => {
          setCurrentPage(page);
        },
        onShowSizeChange: (_, size) => {
          setPageSize(size);
          setCurrentPage(1);
        },
      }}
    />
  );
};

export default ClientUsersTab;
